import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f397baca")

_pushScopeId("data-v-f397baca")
const _hoisted_1 = { class: "bg-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-10 py-20" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fs-2 text-dark me-2 bi bi-arrow-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Back to App", -1)
const _hoisted_7 = { class: "card text-gray-800" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"text-dark\" data-v-f397baca><h1 data-v-f397baca>Attributions Page</h1><div class=\"fs-4\" data-v-f397baca> This wonderfull work never be done without contribution from all these Open Sources. Let us give the attributions to the all authors or contributors of the open source libraries that we use to built this sofware. </div></div><div class=\"love-content my-14 text-center\" data-v-f397baca><span class=\"love-text\" data-v-f397baca>We</span><i class=\"love-icon text-danger bi bi-suit-heart-fill\" data-v-f397baca></i><span class=\"love-text\" data-v-f397baca>Open Source</span></div>", 2)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-dark fs-5 fw-bold" }, " This software is built with: ", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "license-text mb-8 fs-6"
}
const _hoisted_16 = { class: "fs-5 fw-bold text-dark" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("\n") + "The license of the open source project is ")
const _hoisted_18 = { class: "fw-bolder" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" with the following text: ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "text-dark fs-4 d-flex align-items-center mb-8",
            replace: "",
            to: "/app"
          }, {
            default: _withId(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attributionList, (attributionsGroup, groupIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "mb-10",
                  key: groupIndex
                }, [
                  _hoisted_11,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(attributionsGroup, (attribution, attributionIndex) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: attributionIndex }, [
                      _createVNode("span", null, _toDisplayString(attribution.name + " "), 1),
                      _createVNode("span", null, [
                        _hoisted_12,
                        _createVNode("a", {
                          href: attribution.url
                        }, _toDisplayString(attribution.url), 9, ["href"]),
                        _hoisted_13
                      ]),
                      (attributionIndex !== attributionsGroup.length - 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(", ")))
                        : _createCommentVNode("", true),
                      (attributionIndex === attributionsGroup.length - 1)
                        ? (_openBlock(), _createBlock("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _createVNode("u", _hoisted_18, _toDisplayString(attribution.license), 1),
                              _hoisted_19
                            ]),
                            _createVNode("div", null, _toDisplayString(attribution.licenseText), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
})